module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACgSURBVHgB7ZTRDYMwDAVtukhG6ArdqKN0o67QEVikmFgEFKEIkkf+eCchIYNz9xURQgi5Oyogz7eFh8nX3/8qr99HRwGAAjJ5SKMRjWgOyOUWxemQgEY0BezlUxT6fIgzNKI6oCRfRf4NjagKOJLn/yARpwE18isR2kuORmhPORKhveWtEUNp+arc8R3fTXfFdmtWBdjywPJShAkhhJAyM23Tp0/nubDyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/xia.png
// module id = 65+O
// module chunks = 0